module.exports = __webpack_public_path__ + "static/media/department.282fefac.png";